import React from 'react';
import downloadIcon from '../../assets/download.svg';

interface DownloadCSVButtonProps {
  onClick: () => void;
  isLoading?: boolean;
}

const DownloadCSVButton: React.FC<DownloadCSVButtonProps> = ({ onClick, isLoading }) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className="flex items-center gap-2 px-[10px] h-[28px] py-1 text-[#222222] bg-[#FFFFFF] rounded-[10px] hover:bg-gray-50 disabled:opacity-50 shadow-[0px_0px_2px_0px_#E0E0E0]"
    >
      {isLoading ? (
        <>
          <div className="w-4 h-4 border-2 border-[#EEEEEE] border-t-black rounded-full animate-spin" />
          <span>Downloading...</span>
        </>
      ) : (
        <>
          <img src={downloadIcon} alt="Download CSV" className="w-3 h-3 text-[#7A7A7A]" />
          <div className="text-[#7A7A7A] text-[14px] font-normal leading-[20px] tracking-[-0.28px]">Download CSV</div>
        </>
      )}
    </button>
  );
};

export default DownloadCSVButton; 